export function isFloatArray(input) {
    if (Array.isArray(input)) {
        return input.every((item) => typeof item === "number");
    }
    return input instanceof Float32Array;
}
export function isArrayOfFloatArray(input) {
    if (!Array.isArray(input)) {
        return false;
    }
    return input.every(isFloatArray);
}
export function IsDisposable(obj) {
    if (typeof obj !== "object" || obj === null)
        return false;
    return obj.dispose !== undefined;
}
export function isValidable(obj) {
    if (typeof obj !== "object" || obj === null)
        return false;
    return obj.validate !== undefined && obj.invalidate !== undefined;
}
export function IsNumber(value) {
    return typeof value === "number" && !Number.isNaN(value);
}
export function IsString(value) {
    return typeof value === "string";
}
export function HasToString(value) {
    return value !== null && typeof value === "object" && typeof value.toString === "function";
}
//# sourceMappingURL=types.js.map